/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Share_OpenInputs */

const cs_documents_share_open = /** @type {(inputs: Documents_Share_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít odkaz`)
};

const en_documents_share_open = /** @type {(inputs: Documents_Share_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open link`)
};

/**
* | output |
* | --- |
* | "Open link" |
*
* @param {Documents_Share_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_share_open = /** @type {((inputs?: Documents_Share_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Share_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_share_open(inputs)
	return cs_documents_share_open(inputs)
});